/*
 * NotFound Messages
 *
 * This contains all the text for the NotFound component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'components.NotFound';

export default defineMessages({
  notFound: {
    id: `${scope}.notFound`,
    defaultMessage: 'Page not found',
  },
});
